<template>
  <div v-e2e="'trf-table-wrapper'" class="trf-table-wrapper">
    <TrfGlobalLoader v-if="showGlobalLoader" />
    <div v-if="this.status === 'is-empty'">
      <div :class="!this.exibeCabecalho ? 'level is-hidden' : 'level '">
        <div class="level-left">
          <slot name="new-item"></slot>
        </div>
      </div>
      <h1 class="textoNotificacao">{{ this.textoNadaEncontrado }}</h1>
    </div>
    <div v-if="this.status === 'is-danger'">
      <div :class="!this.exibeCabecalho ? 'level is-hidden' : 'level'">
        <div class="level-left">
          <slot name="new-item"></slot>
        </div>
      </div>
      <div class="notification is-danger animated fadeIn">
        Ops... Estamos com problemas... Tente mais uma vez! :(
        <button class="button is-small is-pulled-right" @click="() => this.retry()">Tentar!</button>
      </div>
    </div>

    <div
      :class="`${className} ${containerClass}`"
      v-if="this.status === ''"
    >
      <table
        :class="`table ${isStriped? 'is-striped' : ''} is-hoverable is-fullwidth`"
        :id="this.idTable"
        aria-label="Minhas tarefas"
      >
        <thead>
          <tr>
            <th v-if="(this.isSelectable && this.isMultipleSelection) || isToggleble">
              <label :class="`checkbox ${checkboxClass}`">
                <input
                  v-if="this.isSelectable && this.isMultipleSelection"
                  type="checkbox"
                  :checked="this.checarSeTodosOsItensValidosEstaoSelecionados()"
                  @click="this.selectAllItens"
                />
              </label>
            </th>
            <th
              v-for="(column, index) in this.dataSource.columns"
              :key="column.id ? `id-${column.id}` : `index-${index}`"
              :class="column.classes ? column.classes : ''"
              :style="column.style ? column.style : ''"
            >
              {{ column.label }}
            </th>
            <th v-if="this.showButtons">
              <a v-if="this.isScrollableHorizontal" class="is-invisible"
                >table-head-action-buttons-invisible</a
              >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isSearchEmpty">
            <td :colspan="this.dataSource.columns.length">
              Nenhum resutado para termo buscado.
            </td>
          </tr>
          <template v-for="(item, indexRow) in this.dataSource.itens"
            :key="item.id ? `id-${item.id}` : `index-${indexRow}`">
          <tr
            :class="{
              'is-selected': this.isSelectedItem(item) && isSelectable, 
              'is-hidden': buscaAceita != '' && !this.isResultadoBusca(item, buscaAceita, dataSource.buscaveis),
              'is-toggled': toggleStatus[!!item.id? item.id : indexRow]
            }"
            @click="(event) => this.selectItem(event, item)"
            @dblclick="$emit('duploClick', item)"
          >
            <td v-if="(this.isSelectable && this.isMultipleSelection) || isToggleble">
              <span class="is-flex">
              <label :class="`checkbox ${checkboxClass}`" v-if="this.isSelectable && this.isMultipleSelection">
                <input
                  type="checkbox"
                  :checked="this.isSelectedItem(item)"
                  :disabled="this.isDisabledItem(item)"
                />
              </label>
              <label 
                v-if="isToggleble && !!item && !!item[togglebleItem]"
                :class="{
                  'checkbox': true,
                  'is-toggle-action': true,
                  'is-toggle-show': toggleStatus[!!item.id ? item.id : indexRow],
                  'is-toggle-hide': !toggleStatus[!!item.id ? item.id : indexRow]
                }" 
                @click="(event) => event.stopPropagation()">
                  <input
                    type="checkbox"
                    v-model="toggleStatus[!!item.id ? item.id : indexRow]"
                    :checked="toggleStatus[!!item.id ? item.id : indexRow]"
                  />
                  <span class="icon is-small" :class="{'has-text-primary': !this.isSelectedItem(item) || !isSelectable, 'has-text-white': this.isSelectedItem(item) && isSelectable}">
                    <i class="mdi mdi-24px mdi-chevron-right ml-3" style="transition: transform 0.25s ease 0s; margin-top:-3px" :style="{'transform': toggleStatus[!!item.id ? item.id : indexRow]? 'rotate(90deg)' : 'rotate(0deg)'}" aria-hidden="true"></i>
                  </span>
                </label>
              </span>
            </td>
            <!--Chamada customizada do v-e2e pois já existia um data-label em outro padrão-->
            <td
              v-for="(column, indexColumn) in this.dataSource.columns"
              :key="column.id ? `id-${column.id}` : `index-${indexColumn.id}`"  
              :style="column.styleItems"
              v-e2e:data-cy="`${idTable? idTable : 'datatable'}-cell-${column.name}`"
              v-e2e:data-label="column.label + '&nbsp;'"
            >
              <slot
                v-if="column.slot"
                :name="column.name"
                :item="!!item? item : indexRow"
              ></slot>
              <div
                v-else
                :class="
                  column.classe ? 'tag-status status-' + converterStringParaKebab(item.status) : ''
                "
              >
                {{ this._renderValue(item, column) }}
              </div>
            </td>
            <td v-if="this.showButtons">
              <div
                v-if="_exibirDropdownOptions(item)"
                :class="`dropdown is-right ${
                  this.dataSource.itens.length == indexRow + 1 && this.dataSource.itens.length > 1
                    ? 'is-up'
                    : ''
                }`"
                @click="(event) => this.dropdown(event, !!item?.id? item.id : indexRow,indexRow)"
                :id="`dropdown-${tipoTabela}-${indexRow}-${!!item?.id? item.id : indexRow}`"
              >
                <div class="dropdown-trigger">
                  <span class="icon is-small">
                    <i class="mdi mdi-dots-horizontal mdi-24px" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="dropdown-menu" role="menu">
                  <div class="dropdown-content is-pulled-right">
                    <button
                      v-if="item.status != this.CONCLUIDO && this.showConcluir && (item.isFase || !item.isFase && item.status != this.AGUARDANDO_DADOS && item.status != this.AGUARDANDO_CONFERENCIA)"
                      class="dropdown-item button is-small"
                      type="button"
                      @click="event => this.concluir(event, item)"
                      :disabled="!isConcluirHabilitado(item)"
                      :title="buttonConcluirTitle(item)"
                    >
                      <i class="mdi mdi-check-bold mdi-14px" aria-hidden="true"></i> {{item.isFase? "Concluir fase" : "Concluir"}}
                    </button>
                    <button
                    id="btn-excluir-tarefa"
                      type="button"
                      :class="`dropdown-item ${this.showDelete && !item.tarefaDeFases ? 'button is-small' : 'is-hidden'}`"
                      :disabled="item.isTarefaDeAtendimento || item.isTarefaDoLegalize || item?.opcoesTabela?.excluir?.disabled"
                      :title="buttonExclusaoTitle(item)"
                      @click="(e) => {item?.opcoesTabela?.excluir?.disabled ? void(0) : this.preDelete(item, e, indexRow)}"
                      >
                      <i class="mdi mdi-delete mdi-14px" aria-hidden="true"></i> Excluir
                    </button>
                    <button
                      v-if="item.status != this.CONCLUIDO && this.showTransferir"
                      id="btn-transferir-tarefa"
                      type="button"
                      :class="`dropdown-item ${this.showTransferir ? 'button is-small' : 'is-hidden'}`"
                      @click="(e) => this.shareResponsavelEDepartamento(item, e)"
                    >
                      <i class="mdi mdi-share mdi-14px" aria-hidden="true"></i> {{item.isFase? "Transferir fase" : "Transferir"}} 
                    </button>

                    <button
                      id="btn-editar-tarefa"
                      :class="`dropdown-item ${this.showEdit ? 'button is-small' : 'is-hidden'}`"
                      type="button"
                      :disabled="item?.opcoesTabela?.editar?.disabled"
                      :title="item?.opcoesTabela?.editar?.disabled ? item?.opcoesTabela?.editar?.disabledHint : item?.opcoesTabela?.editar?.hint"
                      @click="(e) => {item?.opcoesTabela?.editar?.disabled ? void(0) : this.select(item, e, indexRow)}"
                    >
                      <i class="mdi mdi-pencil mdi-14px" aria-hidden="true"></i> Editar
                    </button>

                    <button
                      v-if="hasBtnParalisar(item)"
                      v-e2e="'trf-table-opcao-paralisar'"
                      id="btn-paralizar-tarefa"
                      type="button"
                      :class="`dropdown-item ${hasBtnParalisar(item) ? 'button is-small' : 'is-hidden'}`"
                      :title="textoTooltipBtnParalisar(item)"
                      @click="(e) => shareParalisar(item, e)"
                    >
                      <i class="mdi mdi-pause mdi-14px" aria-hidden="true"></i> {{item.isFase? "Paralisar fase" : "Paralisar"}} 
                    </button>

                    <button
                      v-if="hasBtnContinuar(item)"
                      v-e2e="'trf-table-opcao-continuar'"
                      id="btn-continuar-tarefa"
                      type="button"
                      :class="`dropdown-item ${hasBtnContinuar(item) ? 'button is-small' : 'is-hidden'}`"
                      @click="(e) => shareContinuar(item, e)"
                    >
                      <i class="mdi mdi-play mdi-14px" aria-hidden="true"></i> {{item.isFase? "Continuar fase" : "Continuar"}} 
                    </button>

                    <button
                      v-if="this.deveExibirBotaoReabertura(item)"
                      class="dropdown-item button is-small"
                      type="button"
                      @click="(event) => this.reabrir(event, item)"
                    >
                      <i class="mdi mdi-check-bold mdi-14px" aria-hidden="true"></i> {{item.isFase? "Reabrir fase" : "Reabrir"}}
                    </button>

                    <button
                      v-if="this.deveExibirBotaoEditarVencimento(item)"
                      id="btn-editar-prazo-historico"
                      class="dropdown-item button is-small"
                      type="button"
                      @click="(event) => this.editarVencimento(item, event)"
                    >
                      <i class="mdi mdi-calendar-edit mdi-14px" aria-hidden="true"></i> Alterar venc.
                    </button>

                    <button
                      v-if="this.isAvulsa(item) && !this.possuiFasesComStatus(item, CONCLUIDO) && item.status != CONCLUIDO"
                      id="btn-editar-fases-tarefa-avulsa"
                      :class="`dropdown-item ${showEditarAvulsas ? 'button is-small' : 'is-hidden'}`"
                      class="dropdown-item button is-small"
                      type="button"
                      @click="(event) => this.editarFasesTarefaAvulsa(item, event)"
                    >
                      <i class="mdi mdi-file-edit-outline mdi-14px" aria-hidden="true"></i> Editar modelo/fases
                    </button>

                    <button
                      v-if="item.isFase && item.isTarefaDoLegalize"
                      id="btn-detalhes-fase"
                      class="dropdown-item button is-small"
                      type="button"
                      @click="(event) => abrirDetalhesFase(item, event)"
                    >
                      <i class="mdi mdi-information-outline mdi-14px" aria-hidden="true"></i> Detalhes
                    </button>

                  <button
                    v-if="hasBtnEnviarFormulario(item)"
                    v-e2e="'trf-table-opcao-enviar-formulario'"
                    id="btn-enviar-formulario"
                    type="button"
                    :class="`dropdown-item ${hasBtnEnviarFormulario(item) ? 'button is-small' : 'is-hidden'}`"
                    @click="(e) => shareEnviarFormulario(item, e)"
                  >
                    <i class="mdi mdi-email mdi-14px" aria-hidden="true"></i> {{item.isFormularioJaEnviadoAoCliente ? 'Reenviar' : 'Enviar'}} formulário
                  </button>
                  
                  <button
                    v-if="hasBtnVisualizar(item)"
                    v-e2e="'trf-table-opcao-visualizar'"
                    id="btn-visualizar"
                    type="button"
                    :class="`dropdown-item ${hasBtnVisualizar(item) ? 'button is-small' : 'is-hidden'}`"
                    @click="(e) => shareVisualizar(item, e)"
                  >
                    <i class="mdi mdi-eye mdi-14px" aria-hidden="true"></i> {{item.isProcesso? "Visualizar formulário" : "Visualizar"}} 
                  </button>

                  <button
                    v-if="hasBtnAlterarVencimento(item)"
                    v-e2e="'trf-table-opcao-alterar-venc'"
                    id="btn-alterar-venc"
                    type="button"
                    :class="`dropdown-item ${hasBtnAlterarVencimento(item) ? 'button is-small' : 'is-hidden'}`"
                    title="Alterar vencimento"
                    @click="(e) => shareAlterarVencimento(item, e)"
                  >
                    <i class="mdi mdi-calendar-edit mdi-14px" aria-hidden="true"></i> Alterar venc.
                  </button>
                  

                  </div>
                </div>
              </div>
              <button
                v-if="this.showButtonsDefault"
                type="button"
                :class="this.showDelete ? 'button is-small is-pulled-right' : 'is-hidden'"
                @click="(e) => this.preDelete(item, e, indexRow)"
                :disabled="disableExcluirButton"
              >
                <span class="icon"><i class="mdi mdi-delete-outline mdi-24px"></i></span
                >&nbsp;&nbsp;&nbsp;&nbsp;Excluir
              </button>
              <button
                v-if="this.showButtonsDefault && this.showEdit"
                class="button is-small is-pulled-right"
                type="button"
                @click="(e) => this.select(item, e, indexRow)"
              >
                <span class="icon"><i class="mdi mdi-pencil-box-outline mdi-24px"></i></span
                >&nbsp;&nbsp;&nbsp;&nbsp;Editar
              </button>
              <button
                v-if="this.showButtonsDownloadAndView"
                type="button"
                :class="{'button is-small is-pulled-right': true, 'is-loading': item.loading}"
                @click="this.downloadFileById(item)"
              >
                <span class="icon"><i class="mdi mdi-download mdi-18px"></i></span
                >&nbsp;&nbsp;&nbsp;&nbsp;Download
              </button>
              <button
                v-if="this.showButtonsDownloadAndView"
                class="button is-small is-pulled-right"
                :disabled="!item.permiteVisualizacao"
                type="button"
                @click="this.visualizarFile(item)"
              >
                <span class="icon"><i class="mdi mdi-eye mdi-18px"></i></span
                >&nbsp;&nbsp;&nbsp;&nbsp;Visualizar
              </button>
              <slot name="custom-buttons"></slot>
            </td>
          </tr>
          <slot
            v-if="hasSlotLine"
            name="slotLine"
            :item="!!item? item : null"
          ></slot>
          </template>
        </tbody>
      </table>
    </div>

    <TrfPagination
      v-if="paginacao && quantidadeDeItems > 0 && this.status != 'is-loading'"
      :total="quantidadeDeItems"
      :quantidadeDeItemsExibindo="this.dataSource.itens.length"
      :paginaSelecionada="this.pagina"
      :limiteAtual="this.limite"
      @changePage="(pagina) => this.atualizarPagina(pagina)"
      @changeLimite="(limite) => this.atualizarLimite(limite)"
    />

    <TrfModal
      v-if="modalConfirmacaoVisivel"
      idModal="concluir-tarefa"
      :titulo="isPreDeleteFase? 'Excluir fase' : tituloExclusao"
      btnSaveName="Confirmar"
      :isBtnLoading="isAwaitDeleteClass"
      @save="this.delete"
      @close="cancelPreDelete"
    >
      <p class="card-content:" v-html="textoExclusao"></p><br />
    </TrfModal>

    <TrfModal
      v-if="isModalConcluirActive"
      idModal="concluir-tarefa"
      :titulo="tituloModalConclusao"
      btnSaveName="Confirmar"
      :isBtnLoading="isModalConcluirLoading"
      @save="concluirTarefa"
      @close="fecharModalConclusao"
    >
      <p v-html="textoConclusao"></p>

      <p v-html="textoAtencaoModalConclusao" v-if="this.itemEmAlteracao.fases != null"></p>

      <!-- Remover o is-hidden quando adicionar a auditoria na conclusão da tarefa -->
      <div class="is-hidden">
        <p><strong>Motivo para registro na auditoria:</strong></p>
        <textarea name="motivo-conclusao" id="motivo-conclusao" cols="80" rows="5"></textarea>
      </div>
    </TrfModal>

    <TrfModal
      v-if="isModalReabrirActive"
      idModal="reabrir-tarefa"
      :titulo="`Reabrir ${this.itemEmAlteracao.isFase? 'fase' : 'tarefa'}`"
      :btnSaveName="(isModalReabrirFasesPosterioresActive)? 'Sim' : 'Confirmar'"
      :btnCloseName="(isModalReabrirFasesPosterioresActive) ? 'Não' : 'Cancelar'"
      :isBtnLoading="isModalReabrirLoading"
      @save="executarSaveModalReabertura"
      @close="fecharModalReabertura"
    >
    
      <div class="content" v-if="isModalReabrirFasesPosterioresActive">
        <p>
          Identificamos que existe(m) fase(s) com ordem superior que já está(ão) concluída(s). Deseja reabrir essa(s) fase(s) também?
        </p>
        <p>
          <strong>Atenção:</strong> ao clicar em sim, todas as fases posteriores à fase reaberta também serão reabertas.
        </p>
      </div>

      <div class="content" v-else>
        <p>Deseja realmente reabrir esta <strong>{{this.itemEmAlteracao.isFase != null? "fase" : "tarefa"}}</strong>?</p>
      </div>
      
      <!-- Remover o is-hidden quando adicionar a auditoria na reabertura da tarefa -->
      <div class="is-hidden">
        <p><strong>Motivo para registro na auditoria:</strong></p>
        <textarea name="motivo-reabertura" id="motivo-reabertura" cols="80" rows="5"></textarea>
      </div>
    </TrfModal>
  </div>
</template>
<script>
import { service } from "../../views/Dashboard/service/historico-tarefas-service";
import { anexoService } from "../../service/anexo-service";
import { format } from "../../util/intl.js";
import TrfPagination from "../Paginacao/index.vue";
import TrfModal from "../Modal/index.vue";
import TrfGlobalLoader from "../GlobalLoader";
import { syncUtils } from '../../util/sync.utils';
import { toastUtils } from '../../util/toast.utils';
import { pessoaLogada } from "../../stateManagement/pessoaLogada";
import { TipoDeProcessoEnum } from "../../views/Legalize/enums/legalize.enum.js";

export default {
  name: "TrfTabela",
  components: {
    TrfPagination,
    TrfModal,
    TrfGlobalLoader
  },
  props: {
    tipoTabela: {
      type: String,
      default: ""
    },
    tituloExclusao: {
      type: String,
      default: "Excluir tarefa",
    },
    textoExclusao: {
      type: String,
      default: "Deseja excluir?",
    },
    dataConfig: {},
    data: {},
    dataStatus: String,
    quantidadeDeItems: Number,
    nextPage: Function,
    nextLimit: Function,
    isButtonMoreHidden: Boolean,
    textoNadaEncontrado: String,
    paginacao: {
      type: Boolean,
      default: true,
    },
    isButtonsDisplayed: {
      type: Boolean,
      default: true,
    },
    isScrollable: {
      type: Boolean,
      default: false,
    },
    isScrollAnexos: {
      type: Boolean,
      default: false,
    },
    showDropdownOptions: {
      type: Boolean,
      default: false,
    },
    showButtonsDefault: {
      type: Boolean,
      default: true,
    },
    showConcluir: {
      type: Boolean,
      default: false,
    },
    showReabrir: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showEditarAvulsas: {
      type: Boolean,
      default: false,
    },
    showTransferir: {
      type: Boolean,
      default: false,
    },
    showEnviarFormulario: {
      type: Boolean,
      default: false
    },
    showVisualizar: {
      type: Boolean,
      default: false
    },
    showAlterarVencimento: {
      type: Boolean,
      default: false
    },
    showParalisar: {
      type: Boolean,
      default: false
    },
    showEditarVencimento: {
      type: Boolean,
      default: false,
    },
    shouldIgnorePreDelete: {
      type: Boolean,
      default: false,
    },
    paginaSelecionada: {
      type: [Number, String],
      default: 1,
      required: false,
    },
    limiteAtual: {
      type: [Number, String],
      default: 10,
      required: false,
    },
    showGlobalLoader : {
      type: Boolean,
      default: false
    },
    isSelectable : {
      type: Boolean,
      default: true
    },
    isMultipleSelection : {
      type: Boolean,
      default: false
    },
    hasSlotLine : {
      type: Boolean,
      default: false
    },
    isStriped : {
      type: Boolean,
      default: true
    },
    containerClass : {
      type: String,
      default: ""
    },
    isToggleble : {
      type: Boolean,
      default: false
    },
    togglebleItem : {
      type: String
    },
    showButtonsDownloadAndView : {
      type: Boolean,
      default: false
    },
    busca : {
      type: String,
      default: "",
      required: false
    },
    idTable : {
      type: String,
      default: "datatableFixed",
      required: false
    },
    disableExcluirButton : {
      type: Boolean,
      default: false
    },
    tituloModalConclusao: {
      type: String,
      default: "Concluir tarefa"
    },
    checkboxClass: {
      type: String,
      default: "",
      required: false
    },
    liderancas: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  emits: [
    'duploClick',
    'trfTableItemSelected',
    'edicaoDeFasesSelected',
    'trf-tabela-paralisar',
    'trf-tabela-continuar',
    'table-fechou-dropdowns',
    'trf-tabela-enviar-formulario',
    'trf-tabela-visualizar',
    'trf-tabela-alterar-vencimento',
    'trf-tabela-detalhes-fase',
    'update:pagina',
    'update:limite'
  ],
  data() {
    return {
      isDropdownActive: false,
      dataSource: {
        columns: [],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        loadMore: async (event) => console.log("[load more] " + event),
        select: (item) => console.log("[select] " + item),
        delete: async (item) => console.log("[delete] " + item),
        shareResponsavelEDepartamento: (item) => console.log("[share] " + item),
        disableCondition: (item) => console.info("IMPLEMENT: Disable condition"),
        editarVencimento: (item) => console.log("[editarVencimento] " + item),
        concluirTarefa: (item) => console.log("[concluirTarefa]" + item),
        buscaveis: null
      },
      status: "",
      isScrollableHorizontal: false,
      preDeleted: null,
      modalConfirmacaoVisivel: false,
      isAwaitDelete: false,
      isAwaitDeleteClass: false,
      dataSourceItens: { count: 0, firstItem: "" },
      isShowingFullText: true,
      showButtons: true,
      hideButtonMore: false,
      exibeCabecalho: true,
      isModalConcluirActive: false,
      isModalConcluirLoading: false,
      isModalReabrirActive: false,
      isModalReabrirLoading: false,
      pagina: this.paginaSelecionada,
      limite: this.limiteAtual,
      CONCLUIDO: "Concluído",
      ENVIADO: "Enviado",
      PARALISADO: "Paralisada",
      AGUARDANDO_DADOS: "Aguardando dados",
      AGUARDANDO_CONFERENCIA: "A conferir",
      PROCESSO_PARALISADO: "Paralisado",
      itemEmAlteracao: null,
      dropdownItemCondition: null,
      toggleStatus: [],
      buscaAceita: "",
      buscaTimeout: null,
      isSearchEmpty: false,
      isModalReabrirFasesPosterioresActive: false,
      isReabrirFasesPosteriores: false
    };
  },

  mounted: function () {
    document.addEventListener("click", this._onClickDocument);
    this.iniciarItensDesabilitados();
  },

  beforeUnmount: function () {
    document.removeEventListener("click", this._onClickDocument);
  },

  methods: {
    hasBtnVisualizar(item){
      const isStatusValido = item.status != this.CONCLUIDO;
      const opcaoAtivada = this.showVisualizar;
      const isProcesso = item?.isProcesso;
      const isStatusDoProcessoValido = item.status === this.AGUARDANDO_CONFERENCIA;
      return isStatusValido && opcaoAtivada && (isProcesso && isStatusDoProcessoValido);
    },
    hasBtnEnviarFormulario(item) {
      if(!this.showEnviarFormulario) {
        return false;
      }

      const isProcesso = item?.isProcesso;
      if(!isProcesso) {
        return false;
      }
      
      const isLegalizacao = item.tipoDeProcessoId == TipoDeProcessoEnum.LEGALIZACAO;
      if(!isLegalizacao) {
        return false;
      }

      const isStatusValido = item.status != this.CONCLUIDO;
      const podeEnviarFormulario = item.podeEnviarFormulario;
      return isStatusValido && podeEnviarFormulario;
    },
    hasBtnAlterarVencimento(item){
      const isStatusValido = item.status != this.CONCLUIDO;
      const opcaoAtivada = this.showAlterarVencimento;
      const isProcesso = item?.isProcesso;
      const hasPermissaoEditarTarefa = this.verificarPermissaoEditar();
      return isStatusValido && opcaoAtivada && isProcesso && hasPermissaoEditarTarefa;
    },
    hasBtnParalisar(item){
      const isStatusValido = item.status != this.CONCLUIDO && item.status != this.ENVIADO && item.status != this.PARALISADO && item.status != this.PROCESSO_PARALISADO;
      const isStatusValidoProcesso = item.isFase ? true : item.status != this.AGUARDANDO_CONFERENCIA && item.status != this.AGUARDANDO_DADOS;
      const opcaoAtivada = this.showParalisar;
      const podeEditarTarefa = this.verificarPermissaoEditar();
      const naoTemFasesConcluidas = !item.isAlgumaFaseConcluida;
      const naoTemFasesEnviadas = !item.isAlgumaFaseEnviada;
      
      return isStatusValido && opcaoAtivada && podeEditarTarefa && naoTemFasesConcluidas && naoTemFasesEnviadas && isStatusValidoProcesso;
    },
    hasBtnContinuar(item){
      const isStatusValido = [this.PARALISADO, this.PROCESSO_PARALISADO].includes(item.status);
      const opcaoAtivada = this.showParalisar;
      const podeEditarTarefa = this.verificarPermissaoEditar();

      return isStatusValido && opcaoAtivada && podeEditarTarefa
    },
    shareVisualizar(item, event) {
      this._closeDropdownsOptions(event);
      this.$emit("trf-tabela-visualizar", item, event)
    },
    shareEnviarFormulario(item, event) {
      this.$emit("trf-tabela-enviar-formulario", item, event)
    },
    shareParalisar(item, event) {
      if(item.isAlgumaFaseConcluida || item.status == this.CONCLUIDO) {
        toastUtils.dangerToast(`Tarefas e/ou fases com status "Concluído" não podem ser paralisadas.'.`);
        return
      }
      if(item.isAlgumaFaseEnviada || item.status == this.ENVIADO) {
        toastUtils.dangerToast(`Tarefas e/ou fases com status "Enviado" não podem ser paralisadas.'.`);
        return
      }
      this.$emit("trf-tabela-paralisar", item, event)
    },
    shareContinuar(item, event) {
      this.$emit("trf-tabela-continuar", item, event)
    },
    shareAlterarVencimento(item, event) {
      this.$emit("trf-tabela-alterar-vencimento", item, event)
    },
    buttonConcluirTitle(item){
     if(!this.verificarPermissaoConcluirAtendimento(item)){
      return "Usuários sem permissão de editar atendimentos não podem concluir este tipo de tarefa";
     }

     if(!this.verificarRegraConcluirHabilitado(item)) {
      return "A conclusão manual está desativada para esta tarefa. Ela só poderá ser concluída de forma automática.";
     }

     return "";
    },

    buttonExclusaoTitle(item) {
      if(item.isTarefaDeAtendimento) {
        return "Tarefas criadas por atendimento não podem ser excluídas";
      }

      if(item.isTarefaDoLegalize) {
        return "Tarefa não poderá ser excluída, pois a mesma foi criada pelo 'eLegalize', e só poderá ser excluída pelo módulo do 'eLegalize'.";
      }

      return item?.opcoesTabela?.excluir?.disabled ? item?.opcoesTabela?.excluir?.disabledHint : item?.opcoesTabela?.excluir?.hint;
    },
    isConcluirHabilitado(item) {
      const hasPermissaoAtendimento = this.verificarPermissaoConcluirAtendimento(item);
      const isRegraConcluirHabilitado = this.verificarRegraConcluirHabilitado(item);
      return hasPermissaoAtendimento && isRegraConcluirHabilitado;
    },
    verificarPermissaoConcluirAtendimento(item){
      const editarAtendimento = pessoaLogada.hasPermissao("Atendimento", "Editar");
      return (editarAtendimento && item.isTarefaDeAtendimento) || !item.isTarefaDeAtendimento;
    },
    verificarRegraConcluirHabilitado(item) {
      if(item.isFase) {
        return true;
      }
      
      const isLider = !!this.liderancas.find(l => l.id == item.departamentoId);
      const isAdmin = pessoaLogada.current.Administrador || pessoaLogada.current.isSuperAdm;

      if(isAdmin || isLider) {
        return true;
      }

      return !item.desativarConclusaoManual;
    },
    verificarPermissaoEditar(){
      return pessoaLogada.hasPermissao("Tarefas", "Editar");
    },

    iniciarItensDesabilitados() {
      if(!!!this.dataSource.disableCondition) return;
      this.dataSource.itensDisabled = [];
      this.dataSource.itens.forEach(item => {
        if(this.dataSource.disableCondition(item)) {
          this.dataSource.itensDisabled.push(item);
        };
      })
    },
    selectAllItens() {
      if(this.checarSeTodosOsItensValidosEstaoSelecionados()) {
        this.dataSource.itensSelected = [];
      } else {
        const todosOsItensValidos = this.dataSource.itens.filter(item => !!!this.dataSource.disableCondition || !this.dataSource.disableCondition(item));
        this.dataSource.itensSelected = [];
        this.dataSource.itensSelected = todosOsItensValidos;
      }
      this.anounceSelectedItems();
    },
    checarSeTodosOsItensValidosEstaoSelecionados() {
      const todosOsItensValidos = this.dataSource.itens.filter(item => !!!this.dataSource.disableCondition || !this.dataSource.disableCondition(item));
      const validosComoString = JSON.stringify(todosOsItensValidos);
      const selecionadosComoString = JSON.stringify(this.dataSource.itensSelected);
      return todosOsItensValidos.length > 0 && validosComoString == selecionadosComoString;
    },
    async loadMore(event) {
      await this.dataSource.loadMore(event);
    },

    _onClickDocument(event) {
      const dropdown = document.querySelector("table .is-active");
      if (dropdown == null) return;

      let isClickInsideElement = dropdown.contains(event.target);
      if (isClickInsideElement) return;

      this._closeDropdownsOptions();
    },

    _closeDropdownsOptions(event) {
      if (event) event.stopPropagation();
      const dropdowns = document.querySelectorAll("table .is-active");

      for (let dropdown of dropdowns) {
        dropdown.classList.remove("is-active");
      }
      this.$emit('table-fechou-dropdowns', true)
    },

    _verificarDataSourceItens() {
      if (this.dataSource.itens.length > 0) {
        const currentFirstItem = JSON.stringify(this.dataSource.itens[0]);

        if (this.dataSourceItens.firstItem !== currentFirstItem) {
          this.dataSourceItens.count = 0;
          this.dataSourceItens.firstItem = currentFirstItem;
        }

        if (this.dataSourceItens.count < this.dataSource.itens.length) {
          this.dataSourceItens.count = this.dataSource.itens.length;
        }

        this.dataSource.itensSelected = [];
        this.anounceSelectedItems();
        this.iniciarItensDesabilitados();
      }
    },

    _exibirDropdownOptions(item) {
      let existemOpcoes =
        this.showEdit || this.showDelete || (item.status != this.CONCLUIDO && this.showConcluir) || this.deveExibirBotaoReabertura(item) || this.showEditarAvulsas || (item.status != this.CONCLUIDO && this.showTransferir);
      return this.showDropdownOptions && existemOpcoes;
    },

    converterStringParaKebab(string) {
      let stringTratada = string;
      stringTratada = stringTratada.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      stringTratada = stringTratada.replace(
        /[A-Z]+(?![a-z])|[A-Z]/g,
        ($, ofs) => (ofs ? "-" : "") + $.toLowerCase()
      );
      stringTratada = stringTratada.replace(" -", "-");
      stringTratada = stringTratada.replace(" ", "-");
      return stringTratada;
    },

    concluir(event, item) {
      this._closeDropdownsOptions(event);

      if([this.PROCESSO_PARALISADO,this.PARALISADO].includes(item.status) || item.isAlgumaFaseParalisada) {
        // @TODO Esta validação deve ser externalizada quando o componente de tabela for refatorado
        // dentro do possível devemos evitar adicionar novas regras de negócio diretamente a tabela.
        const msgTarefas = 'Tarefas e/ou fases com status "Paralisada" não podem ser concluídas.';
        const msgNegocios = 'Negócios e/ou fases com status "Paralisado" não podem ser concluídos.';
        toastUtils.dangerToast((item.isProcesso || item.isFaseProcesso) ? msgNegocios : msgTarefas);
        return;
      }
      if(item.podeConcluir != undefined && item.podeConcluir == false) {
        // @TODO Esta validação deve ser externalizada quando o componente de tabela for refatorado
        // dentro do possível devemos evitar adicionar novas regras de negócio diretamente a tabela.
        toastUtils.dangerToast("A fase não pode ser concluída fora de ordem.");
        return;
      }

      this.itemEmAlteracao = item;
      this.isModalConcluirActive = true;
    },

    fecharModalConclusao() {
      document.querySelector("#motivo-conclusao").value = "";
      this.itemEmAlteracao = null;
      this.isModalConcluirActive = false;
    },

    setarTituloModalConclusao() {
      let tipoDeItem = '';

      if(this.itemEmAlteracao.isProcesso) {
        tipoDeItem = 'processo';
      } else {
        tipoDeItem = this.itemEmAlteracao.isFase? 'fase' : 'tarefa';
      }

      return `Concluir ${tipoDeItem}`;
    },

    reabrir(event, item) {
      this._closeDropdownsOptions(event);
      this.itemEmAlteracao = item;
      this.isModalReabrirActive = true;
      this.isReabrirFasesPosteriores = false;
    },

    executarSaveModalReabertura() {
      if (!this.isModalReabrirFasesPosterioresActive && this.itemEmAlteracao.possuiFasesPosterioresConcluidas) {
        this.isModalReabrirFasesPosterioresActive = true;
      } else if (this.isModalReabrirFasesPosterioresActive) {
        this.isReabrirFasesPosteriores = true;
        this.reabrirTarefa();
      } else {
        this.reabrirTarefa();
      }
    },

    async reabrirTarefa() {
      let motivoReabertura = document.querySelector("#motivo-reabertura").value;

      this.isModalReabrirLoading = true;

      let item = this.itemEmAlteracao;
      let success;

      if (item.isFase) {
        let faseId = item.faseId ? item.faseId : item.id;
        success = await service.reabrir(item.historicoTarefaId, faseId, motivoReabertura, this.isReabrirFasesPosteriores);
      } else {
        success = await service.reabrir(item.id, null, motivoReabertura);
      }

      if (success) {
        this.atualizarPagina(this.pagina);
        
        if(this.dataSource.reabrirTarefa) {
          this.dataSource.reabrirTarefa(item);
        }
      }

      this.isModalReabrirLoading = false;

      this.fecharModalReaberturaAposSalvar();
    },

    fecharModalReabertura() {
      if(this.isModalReabrirFasesPosterioresActive && !this.isReabrirFasesPosteriores) {
        this.reabrirTarefa();
      }
      
      this.fecharModalReaberturaAposSalvar();
    },

    fecharModalReaberturaAposSalvar() {
      this.itemEmAlteracao = null;
      this.isModalReabrirActive = false;
      this.isReabrirFasesPosteriores = false;
      this.isModalReabrirFasesPosterioresActive = false;
    },

    fecharModalReaberturaSemReabrirAnteriores() {
      this.isReabrirFasesPosteriores = false;
      this.reabrirTarefa();
    },

    select(item, event, index) {
      this._closeDropdownsOptions(event);
      this.dataSource.select(item, event, index);
    },

    downloadFileById(item) {
      item.loading = true;
      const response = anexoService.downloadById(item.id,item.type,item.nome);
      response.then(() => {
        item.loading = false;
      });
    },

    async visualizarFile(item) {
      const { routerUtils } = await import('../../util/router.utils');
      const routeData = this.$router.resolve({path:'/urlanexo',query: { id: item.id, type: item.type}});
      window.open(routeData.href, '_blank');
    },

    preDelete(item, event, index) {
      this._closeDropdownsOptions(event);
      if(item?.status == this.CONCLUIDO || (Array.isArray(item.fases) && item.fases.some(fase => {
        return fase?.status == this.CONCLUIDO || fase?.status?.nome == this.CONCLUIDO;
      }))) {
        const tarefas = (item.isProcesso || item.isFaseProcesso) ? 'Negócios' : 'Tarefas'; 
        toastUtils.dangerToast(`${tarefas} e/ou fases com status "Concluído" não podem ser excluídos.`);
        return;
      }
      this.preDeleted = item;
      if (this.shouldIgnorePreDelete) {
        this.dataSource.delete(item, event, index);
      } else {
        if(this.dataSource.preDelete) {
          this.dataSource.preDelete(item, event, index)
        }
        this.modalConfirmacaoVisivel = item.status != "Concluído";
      }
    },

    cancelPreDelete() {
      this.preDeleted = null;
      this.modalConfirmacaoVisivel = false;
    },

    async delete() {
      this.isAwaitDeleteClass = true;

      try {
        await this.dataSource.delete(this.preDeleted);
      } finally {
        this.isAwaitDeleteClass = false;
        this.modalConfirmacaoVisivel = false;
      }
    },

    async concluirTarefa() {
      try {
        this.isModalConcluirLoading = true;
        this.dataSource.concluirTarefa(this.itemEmAlteracao);
      } finally {
        setTimeout(() => {
          this.isModalConcluirLoading = false;
          this.fecharModalConclusao();
        }, 1000);
      }
    },

    shareResponsavelEDepartamento(item, event) {
      this._closeDropdownsOptions(event);
      this.dataSource.shareResponsavelEDepartamento(item);
    },

    editarVencimento(item, event) {
      this._closeDropdownsOptions(event);
      this.dataSource.editarVencimento(item);
    },

    deveExibirBotaoEditarVencimento(item) {
      return item.status != this.CONCLUIDO && !item.recorrencia && this.showEditarVencimento;
    },
    deveExibirBotaoReabertura(item) {
      return item.status === this.CONCLUIDO && ((!item.isAdmin && item.isTarefaDoLegalize) 
          || (item.isFase && item.isAdmin) 
          || (!!!item.isFase && this.showReabrir && (!!!item.fases || item.fases.length == 0)));
    },
    isSelectedItem(item) {
      return this.dataSource.itensSelected.some(
        (itemSelected) => JSON.stringify(itemSelected) === JSON.stringify(item)
      )
    },
    _renderValue(row, column) {
      const properties = column.name.split(".");
      let value = row;

      for (let propertie of properties) {
        value = value[propertie];
      }

      if (column.format) return column.format(value);
      return this.isShowingFullText ? value : format(value);
    },
    isDisabledItem(item) {
      return (this.isMultipleSelection && this.dataSource.itensDisabled
        ? this.dataSource.itensDisabled.some(
            (itemDisabled) => JSON.stringify(itemDisabled) === JSON.stringify(item)
          )
        : false);
    },

    selectItem(event, item) {
      if(this.isDisabledItem(item)) {
        return;
      }
      if (this.isMultipleSelection) {
        const isItemSelected = this.isSelectedItem(item);
        if (isItemSelected) {
          this.dataSource.itensSelected = this.dataSource.itensSelected.filter(
            (itemChecked) => JSON.stringify(itemChecked) !== JSON.stringify(item)
          );
        } else {
          this.dataSource.itensSelected.push(item);
        }
      } else {
        this.dataSource.itensSelected = [item];
      }
      this.anounceSelectedItems();
    },
    anounceSelectedItems() {
      this.$emit("trfTableItemSelected", this.dataSource.itensSelected)
    },
    async retry() {
      this.dataSource.filter();
    },
    encontrarEmString(string, busca) {
      const stringfied = "" + string;
      const valorNormalizado = stringfied.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const buscaNormalizada = busca.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return valorNormalizado.includes(buscaNormalizada);
    },
    isResultadoBusca(item, busca, buscaveis) {
      if(!!!buscaveis) {
        const colunas = this.dataSource.columns;
        buscaveis = [];
        colunas.forEach((coluna) => {
          if(!coluna.slot) {
            buscaveis.push(coluna.name);
          }
        })
      };
      const resultado = buscaveis.some(buscavel => {
        return this.encontrarEmString(item[buscavel], busca);
      });
      return resultado
    },
    dropdown(event, itemId,indexRow) {    
      event.preventDefault();
      event.stopPropagation();

      let isActive = document.getElementById(`dropdown-${this.tipoTabela}-${indexRow}-${itemId}`).classList.contains("is-active");
      this._closeDropdownsOptions();

      if (isActive) return;

      document.getElementById(`dropdown-${this.tipoTabela}-${indexRow}-${itemId}`).classList.toggle("is-active");
    },
    click_tela_fechar_dropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.fechar_dropdown();
      }
    },
    atualizarPagina(pagina) {
      this.pagina = pagina;
      this.$emit("update:pagina", this.pagina);
    },
    atualizarLimite(limite) {
      this.limite = limite;
      this.$emit("update:limite", this.limite);
    },
    checkEmptySearch() {
      if(this.buscaAceita == "") {
        return false;
      }
      const elementsHidden = document.querySelectorAll(`.${this.idTable} tbody tr.is-hidden`);
      return elementsHidden.length == this.data.length;
    },
  
    isAvulsa(historico) {
      return !historico.recorrencia && !historico.isFase && !historico.complementoTemplate;
    },

    possuiFasesComStatus(historico, status) {
      let fases = historico.fases;
      let isTarefaDeFases = fases != null;
      
      if(!isTarefaDeFases) {
        return false;
      }

      for (let i = 0; i < fases?.length; i++) {
        if (fases[i].status === status) {
            return true;
        }
      }

      return false;
    },

    editarFasesTarefaAvulsa(item) {
      this.$emit("edicaoDeFasesSelected", item);
    },

    textoTooltipBtnParalisar(item) {
      const mapa = {
        isFase: 'fase',
        isProcesso: 'negócio'
      };

      const textoParalisar = item.isFase
        ? mapa.isFase
        : item.isProcesso
        ? mapa.isProcesso
        : 'tarefa';

      return `Paralisar ${textoParalisar}`;
    },

    abrirDetalhesFase(item, event) {
      this._closeDropdownsOptions(event);
      this.$emit('trf-tabela-detalhes-fase', item);
    }
  
  },
  computed: {
    className() {
      if (this.isScrollable) {
        return 'table-container is-tableScrollable';
      } else if (this.isScrollAnexos) {
        return 'table-container is-anexosScroll';
      } else {
        return 'table-container is-StandardScroll';
      }
    },
    isPreDeleteFase() {
      return !!this.preDeleted?.isFase;
    },
    textoConclusao() {
      let texto;
      texto = "esta <strong>tarefa</strong>"

      if (this.itemEmAlteracao?.isProcesso) {
        texto = "este <strong>negócio</strong>"
      }

      if (this.itemEmAlteracao.isFase) {
        texto = "esta <strong>fase</strong>"
      } 

      return `Deseja realmente concluir ${texto}?<br /><br />`
    },
    textoAtencaoModalConclusao() {
      let texto;
      if (this.itemEmAlteracao?.isProcesso) {
        texto = "a este negócio"
      } else {
        texto = "a esta tarefa"
      }

      return `<strong>Atenção:</strong> Ao clicar em confirmar, as fases correspondentes ${texto} também serão concluídas.`
    }
  },
  watch: {
    dataConfig: {
      immediate: true,
      handler() {
        this.dataSource = this.dataConfig;
      },
    },
    busca: {
      immediate: true,
      handler(novo, antigo) {
        if(novo == antigo) return;
        if(!!this.buscaTimeout) {
          clearTimeout(this.buscaTimeout);
        }
        this.buscaTimeout = setTimeout(() => {
          this.buscaAceita = novo;
          syncUtils.aguardaSincronia(() => {this.isSearchEmpty = this.checkEmptySearch()});
        }, 225);
      },
    },
    dataStatus: {
      immediate: true,
      handler() {
        this.status = this.dataStatus;
      },
    },
    isButtonsDisplayed: {
      immediate: true,
      handler() {
        this.showButtons = this.isButtonsDisplayed;
      },
    },
    isButtonMoreHidden: {
      immediate: true,
      handler() {
        this.hideButtonMore = this.isButtonMoreHidden;
      },
    },
    data: {
      immediate: true,
      handler() {
        if (this.dataSource) {
          this.dataSource.itens = this.data;
          this._verificarDataSourceItens();
        }
      },
    },
    paginaSelecionada: {
      immediate: true,
      handler() {
        if (this.paginaSelecionada) {
          this.pagina = this.paginaSelecionada;
          this.itensSelected = [];
        }
      },
    },
    limiteAtual: {
      immediate: true,
      handler() {
        if (this.limiteAtual) {
          this.limite = this.limiteAtual;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";

#motivo-conclusao {
  resize: none;
  padding: 4px;
}

#motivo-reabertura {
  resize: none;
  padding: 4px;
}

.is-tableScrollable {
  overflow-y: auto;
  max-height: 70vh;
}

.is-anexosScroll {
  overflow-y: auto;
  max-height: 27vh;
}

.is-tableScrollable thead th {
  // position: sticky;
  top: 0;
  z-index: 5;
}

thead {
  width: 100%;
  height: 40px;
  font-size: 14px;
  padding-top: 10px;
}
.table-container.is-StandardScroll,.table-container.is-tableScrollable {
  width: 100%;
  @media screen and (min-width: $mobile) {
    overflow: inherit !important;
  }
}

.table-container.is-anexosScroll {
  width: 100%;
}

tbody > tr {
  width: 100%;
  height: 41px;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  margin-left: 100px;
}
tbody > tr > td {
  margin-top: 50px;
  border-bottom: 0;
}
.dropdown-content > button {
  border: none;
  font-size: 16px;
}
.textoNotificacao {
  margin: 9% 0 15% 0;
  text-align: center;
  font-size: 21px;
  color: #31708f;
}
.tag-status {
  color: #ffff;
  border-radius: 1rem;
  text-align: center;
  font-weight: bold;
  width: auto;
}

.status-ativa,
.status-concluido,
.status-concluida {
  background-color: $success;
}
.status-atrasada {
  background-color: $danger;
}

.status-paralisada,.status-paralisado {
  background-color: $grey;
}
.status-enviado {
  background-color: #547faa;
}
.status-a-fazer {
  background-color: $info;
}
.status-inativa {
  background-color: #969696;
}
.status-aguardando-dados {
  background-color: #547CAC;
}
.status-a-conferir {
  background-color: #C4B43C;
}
</style>
